<template>
  <div>
    <label class="control-label" :class="required === false ? '' : 'required'" for="dob" v-if="this.$store.state.requirements[field]">
      {{ computeReportableCaption(field, this.label, this.$store.state.lang.value.toLowerCase()) }}
    </label>
    <label class="control-label" :class="required === false ? '' : 'required'" v-else>
      {{computeCaption (label, this.$store.state.lang.value.toLowerCase())}}
    </label>
    <div class="form-group">
      <el-select filterable v-model="dateObject.month" placeholder="Month" :name="label + ' month'" class="date-select"
                 :disabled="disabled" :style="inputFormats ? 'order:' + inputFormats.indexOf('m') : ''"
                 @change="changeMonth(dateObject.month)">
        <el-option
          v-for="(month, key) in monthsArray"
          :key="key"
          :label="computeCaption(month.label, $store.state.lang.value.toLowerCase())"
          :value="month.value"
          v-if="month.visible"
        >
        </el-option>
      </el-select>
      <el-select filterable v-model="dateObject.day" placeholder="Day" :name="label + ' day'" class="date-select"
                 :disabled="disabled" :style="inputFormats ? 'order:' + inputFormats.indexOf('d') : ''">
        <el-option
          v-for="(day, key) in daysArray"
          :key="key"
          :label="day"
          :value="day"
        >
        </el-option>
      </el-select>
      <el-select filterable v-model="dateObject.year" placeholder="Year" :name="label + ' year'" class="date-select"
                 :disabled="disabled" :style="inputFormats ? 'order:' + inputFormats.indexOf('y') : ''"
                 @change="changeYear(dateObject.year)">
        <el-option
          v-for="(year, key) in yearsArray"
          :key="key"
          :label="year"
          :value="year"
        >
        </el-option>
      </el-select>
    </div>
    <div class="default-grey font-small" v-show="getFieldDescription(field)"
         v-html="getFieldDescription(field) || ''"></div>
    <small class="text-danger" v-if="errorDate"
           v-text="computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())">
      {{ computeCaption(errorDate, this.$store.state.lang.value.toLowerCase()) }}
    </small>
  </div>
</template>

<script>
import {Col, Row, Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {LayoutCalculationUtils} from '../../../../../../utils/LayoutCalculation'
export default {
  name: 'DobSection',
  props: ['label', 'required', 'field', 'disabled', 'dateValue', 'yearsProp', 'monthsProp', 'daysProp', 'restrictDate', 'formatDate'],
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils,
    SettingsUtils,
    LayoutCalculationUtils
  ],
  data () {
    return {
      dateObject: {
        year: '',
        month: '',
        day: '',
        composedDate: ''
      },
      monthsArray: [
        {value: '01', label: 'January', visible: true},
        {value: '02', label: 'February', visible: true},
        {value: '03', label: 'March', visible: true},
        {value: '04', label: 'April', visible: true},
        {value: '05', label: 'May', visible: true},
        {value: '06', label: 'June', visible: true},
        {value: '07', label: 'July', visible: true},
        {value: '08', label: 'August', visible: true},
        {value: '09', label: 'September', visible: true},
        {value: '10', label: 'October', visible: true},
        {value: '11', label: 'November', visible: true},
        {value: '12', label: 'December', visible: true}
      ],
      daysArray: [
      ],
      yearsArray: [
      ],
      errorDate: ''
    }
  },
  async beforeMount () {
    if (this.dateValue) {
      let date = this.dateValue.split('-')
      this.dateObject.year = date[0]
      this.dateObject.month = date[1].padStart(2, '0')
      this.dateObject.day = date[2].padStart(2, '0')
    }
    if (this.daysProp !== undefined && this.daysProp.length > 0) {
      this.daysArray = this.daysProp
    } else {
      this.pushDays(31)
    }
    if (this.monthsProp !== undefined && this.monthsProp.length > 0) {
      this.monthsArray = this.monthsArray.filter(month => {
        return this.monthsProp.includes(month.label)
      })
    }
    if (this.yearsProp !== undefined && this.yearsProp.length > 0) {
      this.yearsArray = this.yearsProp
    } else {
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i >= 1900; i--) {
        this.yearsArray.push(i)
      }
    }
  },
  methods: {
    validate () {
      if (this.required === false) {
        return true
      }
      if (this.dateObject.composedDate === '') {
        this.errorDate = this.label + ' field is required'
        if (this.dateObject.month === '') {
          document.getElementsByName(this.label + ' month')[0].focus()
          return false
        }
        if (this.dateObject.day === '') {
          document.getElementsByName(this.label + ' day')[0].focus()
          return false
        }
        if (this.dateObject.year === '') {
          document.getElementsByName(this.label + ' year')[0].focus()
          return false
        }
      } else {
        this.errorDate = ''
      }
      return true
    },
    changeYear (year) {
      const month = this.dateObject.month ? this.dateObject.month : '01'
      const days = new Date(year, month, 0).getDate()
      this.pushDays(days)
      if (this.restrictDate === true) {
        if (this.yearsArray[0] === year) {
          const d = new Date()
          let currentMonth = d.getMonth() + 1
          this.monthsArray = this.monthsArray.map((month) => {
            if (month.value > currentMonth) {
              return {...month, visible: false}
            }
            return month
          })
        } else {
          this.monthsArray = this.monthsArray.map((month) => {
            return {...month, visible: true}
          })
        }
      }
      if (!this.daysArray.includes(this.dateObject.day) && this.dateObject.day !== '') {
        this.errorDate = 'The chosen date was not valid. Please choose another!'
        this.dateObject.day = ''
      }
      if (this.dateObject.month !== '') {
        if (this.monthsArray.find(month => month.value === this.dateObject.month).visible === false) {
          this.errorDate = 'The chosen date was not valid. Please choose another!'
          this.dateObject.month = ''
        }
      }
    },
    changeMonth (month) {
      const now = new Date()
      const year = this.dateObject.year ? this.dateObject.year : 2020
      const date = new Date(year, month, 0)
      let days = new Date(year, month, 0).getDate()
      if (date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
        days = now.getDate()
      }
      this.pushDays(days)
      if (this.restrictDate === true) {
        if (this.yearsArray[0] === this.dateObject.year && this.monthsArray[this.monthsArray.length - 1].label === this.monthsArray[month - 1].label) {
          const d = new Date()
          let currentDay = d.getDate()
          this.pushDays(currentDay)
        }
      }
      if (!this.daysArray.includes(this.dateObject.day) && this.dateObject.day !== '') {
        this.errorDate = 'The chosen date was not valid. Please choose another!'
        this.dateObject.day = ''
      }
    },
    pushDays (numberOfDays) {
      this.daysArray = []
      for (let i = 1; i <= numberOfDays; i++) {
        if (i < 10) {
          this.daysArray.push('0' + i)
        } else {
          this.daysArray.push('' + i)
        }
      }
    }
  },
  computed: {
    inputFormats () {
      if (this.formatDate) {
        return this.formatDate.split('/')
      }
      return false
    }
  },
  watch: {
    dateObject: {
      handler: function (val) {
        if (this.dateObject.year !== '' && this.dateObject.month !== '' && this.dateObject.day !== '') {
          this.dateObject.composedDate = this.dateObject.year + '-' + this.dateObject.month + '-' + this.dateObject.day
        }
        if (this.dateObject.year === '' || this.dateObject.month === '' || this.dateObject.day === '') {
          this.dateObject.composedDate = ''
        }
      },
      deep: true
    },
    'dateObject.composedDate': {
      handler: function (val) {
        if (val !== '') {
          this.errorDate = ''
        }
        this.$emit('updateDob', this.dateObject)
      }
    },
    'dateValue': {
      handler: function (val) {
        if (this.dateValue) {
          let date = this.dateValue.split('-')
          this.dateObject.year = date[0]
          this.dateObject.month = date[1].padStart(2, '0')
          this.dateObject.day = date[2].padStart(2, '0')
        } else if (this.dateValue === '') {
          this.dateObject.year = ''
          this.dateObject.month = ''
          this.dateObject.day = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
.form-control{
  padding: 0px 10px;
}
.date-select:nth-of-type(1){
  flex:2;
}
.date-select:nth-of-type(2){
  flex:1.5;
}
.date-select:nth-of-type(3){
  flex:1.5;
}
.form-group {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  span{
    font-size: 25px;
    margin: 0 5px;
    color:$font-color;
  }
}
@media only screen and (max-width: 900px) {
  .form-group{
    justify-content: space-between;
    padding: 0!important;
  }
  .date-select{
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/MultipleUseParts/Date.vue